import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { SentenceCasePipe } from '../../../../shared/pipes/sentence-case.pipe';
import {
  EnrichedUserCreateTemplate,
  UserApplication,
} from '../../models/user.models';
import { UserTemplatePipe } from '../../pipes/user-template.pipe';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-select-user-template',
  templateUrl: './select-user-template.component.html',
  styleUrls: ['./select-user-template.component.scss'],
  imports: [MaterialModule, UserTemplatePipe],
  providers: [SentenceCasePipe],
})
export class SelectUserTemplateComponent implements OnInit, OnDestroy {
  @Output() selectTemplateSignal =
    new EventEmitter<EnrichedUserCreateTemplate>();

  templates: EnrichedUserCreateTemplate[] = [];

  isLoading = true;

  private destroy$ = new Subject();

  constructor(
    private userService: UserService,
    private sentenceCasePipe: SentenceCasePipe
  ) {}

  ngOnInit() {
    this.userService
      .getUserTemplates()
      .pipe(
        tap((templates) => {
          this.templates = templates || [];
        }),
        tap(() => {
          this.isLoading = false;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  selectTemplate(template: EnrichedUserCreateTemplate) {
    this.selectTemplateSignal.emit(template);
  }

  getApplicationsList(applications: UserApplication[]) {
    return applications
      .sort((a, b) => a.localeCompare(b))
      .map((application) => this.sentenceCasePipe.transform(application))
      .join(', ');
  }
}
